<template>
  <div
    class="vs-component vs-con-textarea"
    :class="[
      `vs-textarea-${color}`,
      $attrs.class,
      {
        'textarea-danger': isCounterDanger,
        focusx: isFocus,
      },
    ]"
    :style="[$attrs.style, textareaStyle]"
  >
    <h4 v-if="label">{{ label }}</h4>
    <textarea
      class="vs-textarea"
      :value="currentValue"
      v-bind="textareaAttrs"
      @input="handleInput"
      @focus="handleFocus"
      @blur="handleBlur"
    />
    <div v-if="counter" class="count vs-textarea--count">
      {{ currentLength }} / {{ counter }}
    </div>
  </div>
</template>

<script>
export default {
  name: "VsTextarea",
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [String, Number],
      default: undefined,
    },
    value: {
      type: [String, Number],
      default: undefined,
    },
    label: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: "primary",
    },
    counter: {
      type: [Number, String],
      default: null,
    },
    counterDanger: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: null,
    },
    width: {
      type: String,
      default: null,
    },
  },
  emits: [
    "update:modelValue",
    "update:counterDanger",
    "input",
    "focus",
    "blur",
  ],
  data() {
    return {
      isFocus: false,
    };
  },
  computed: {
    currentValue() {
      if (this.modelValue !== undefined) {
        return this.modelValue;
      }
      return this.value === undefined ? "" : this.value;
    },
    currentLength() {
      return this.currentValue ? String(this.currentValue).length : 0;
    },
    isCounterDanger() {
      return Boolean(this.counter && this.currentLength > Number(this.counter));
    },
    textareaAttrs() {
      const attrs = { ...this.$attrs };
      ["class", "style", "onInput", "onFocus", "onBlur"].forEach(
        (key) => delete attrs[key]
      );
      return attrs;
    },
    resolvedColor() {
      if (
        this.color.startsWith("#") ||
        this.color.startsWith("rgb") ||
        this.color.startsWith("hsl") ||
        this.color.startsWith("var(")
      ) {
        return this.color;
      }
      return `rgba(var(--vs-${this.color}), 1)`;
    },
    textareaStyle() {
      return {
        border: `1px solid ${
          this.isFocus ? this.resolvedColor : "rgba(0, 0, 0,.08)"
        }`,
        height: this.height,
        width: this.width,
      };
    },
  },
  watch: {
    isCounterDanger: {
      immediate: true,
      handler(value) {
        this.$emit("update:counterDanger", value);
      },
    },
  },
  methods: {
    handleInput(event) {
      this.$emit("update:modelValue", event.target.value);
      this.$emit("input", event.target.value);
    },
    handleFocus() {
      this.isFocus = true;
      this.$emit("focus");
    },
    handleBlur() {
      this.isFocus = false;
      this.$emit("blur");
    },
  },
};
</script>
